(function($, window, document){
	/**
	 *
	 */
	window.ImageHelper = {

		/**
		 * Fit an image or background in it's parent container.
		 *
		 * Optionally you can specify the width and the height of the image on the dom element to prevent
		 * wrong value when the image isn't totally loaded.
		 *
		 * @param {object} $element                   Jquery object referencing to the parent (if background) or image.
		 * @param {string|number=} focusTop           The top focus point in the image. Pass either a numeral value corresponding to the point in pixel in the original image or a percentage '50%'. Default is 50%.
		 * @param {string|number=} focusLeft          The left focus point in the image. Pass either a numeral value corresponding to the point in pixel in the original image or a percentage '50%'. Default is 50%.
		 * @param {boolean=} isBackground             If the image you want to resize is a background, specify it here. You MUST pass the backgroundWidth and backgroundHeight if so.
		 * @param {number|boolean=} backgroundWidth   Width of the background
		 * @param {number|boolean=} backgroundHeight  Height of the background
		 * @param {boolean=} backgroundFixed          Tells if the background has a fixed attachment
		 * @param {number=}  topRequiredSpace          Tells the required space where the background has to be for a fixed background
		 */
		fitImageInParent: function($element, focusTop, focusLeft, isBackground, backgroundWidth, backgroundHeight, backgroundFixed, topRequiredSpace) {
			if((!$element || $element.length <= 0) && !isBackground) {
				return;
			}

			focusTop   = typeof $element.data('focus-top') !== 'undefined'  ? $element.data('focus-top').toString() : focusTop  || '50%';
			focusLeft  = typeof $element.data('focus-left') !== 'undefined'  ? $element.data('focus-left').toString() : focusLeft  || '50%';

			var $parent   = isBackground ? $element : $element.parent();

			var parentWidth  = $parent.innerWidth(),
				parentHeight = $parent.innerHeight();

			if(topRequiredSpace) {
				parentHeight = parentHeight + topRequiredSpace;
			}

			//Acquire image width and height
			var originalWidth  = !isBackground ? $element.data('width')  || $element.width()  : $element.data('width')  || backgroundWidth;
			var originalHeight = !isBackground ? $element.data('height') || $element.height() : $element.data('height') || backgroundHeight;

			var widthRatio  = parentWidth / originalWidth;
			var heightRatio = parentHeight / originalHeight;

			var finalWidth, finalHeight;

			//The width will serve as base
			if(widthRatio > heightRatio){
				finalWidth  = parentWidth;
				finalHeight = finalWidth * originalHeight / originalWidth;
			}
			//The height will serve as base
			else{
				finalHeight = parentHeight;
				finalWidth  = finalHeight * originalWidth / originalHeight;
			}

			var top, left, topPosition, leftPosition, backgroundAttachment;

			if (focusTop.indexOf('%') > -1) {
				topPosition = finalHeight * (originalHeight * (parseInt(focusTop) / 100)) / originalHeight;
			} else {
				topPosition = finalHeight * parseInt(focusTop) / originalHeight;
			}

			if (focusLeft.indexOf('%') > -1) {
				leftPosition = finalWidth * (originalWidth * (parseInt(focusLeft) / 100)) / originalWidth;
			} else {
				leftPosition = finalWidth * parseInt(focusLeft) / originalWidth;
			}

			top = -(topPosition - (parentHeight / 2 ));
			left = -(leftPosition - (parentWidth / 2 ));

			if (topPosition < parentHeight / 2) {
				top = 0;
			} else if (finalHeight + top < parentHeight) {
				top = -(finalHeight - parentHeight);
			}

			//À tester
			if (leftPosition < parentWidth / 2) {
				left = 0;
			} else if (finalWidth + left < parentWidth) {
				left = -(finalWidth - parentWidth);
			}

			if (backgroundFixed) {
				top += $element.offset().top

				if (isBackground) {
					backgroundAttachment = 'fixed';
				}
			}

			if (topRequiredSpace) {
				top -= topRequiredSpace;
			}

			/*this.imageProperties = {
			 'top':  	    top,
			 'left':         left,
			 'topPosition':  topPosition,
			 'leftPosition': leftPosition,
			 'finalWidth':   finalWidth,
			 'finalHeight':  finalHeight,
			 'parentWidth':     parentWidth,
			 'parentHeight':    parentHeight,
			 'topOffset':	this.$el.offset().top
			 };*/

			//var position = this.calculateAdjustedPosition(top, left);

			if (isBackground) {
				$element.css({
					'overflow':              'hidden',
					'background-position':   left + 'px ' + top + 'px',
					'background-size':       finalWidth + 'px ' + finalHeight + 'px',
					'background-attachment': backgroundAttachment || null
				});
			} else {
				$element.css({
					'position':   'absolute',
					'max-width':  'none',
					'max-height': 'none',
					'width':      finalWidth,
					'height':     finalHeight,
					'top':        top,
					'left':		  left
				});
			}
		},
		fitBackground: function() {

		}
	};
}(jQuery, window, document));
